import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Eye, EyeOff, Lock, LucideAngularModule, User } from "lucide-angular";
import { CommonTranslateModule } from "src/app/shared/utils/common-translate.module";
import { LoginFormComponent } from "./login-form.component";

@NgModule({
  declarations: [LoginFormComponent],
  providers: [],
  imports: [
    CommonModule,
    CommonTranslateModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    LucideAngularModule.pick({ User, Lock, Eye, EyeOff }),
  ],
  exports: [LoginFormComponent],
})
export class LoginFormModule {}
